import { Card, CardContent, CardMedia, styled, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const StyeledCard = styled(Card)((theme) => ({
    
    width: '150px',
    maxWidth: '150px',
    height: '200px',
    borderRadius: '10px',
    background: '#fa578e80',
    padding: '10px'
}))
const BrandCard = (props) => {

    return (
        <>
            <Link to={props?.cardUrl} style={{textDecoration:'none'}}>

                <StyeledCard >
                    <CardMedia component={"img"} height={145} image={props?.cardImage} alt={props?.cardText} sx={{ objectFit: 'contain' }} />
                    <CardContent sx={{ display: 'flex', flexDirection: 'row', padding: '5px', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" fontSize={'1rem'} sx={{textTransform: 'capitalize'}}>{props?.cardText} </Typography>

                    </CardContent>
                </StyeledCard>
            </Link>
        </>
    )
}

export default BrandCard